import type { Page, SupplierInput, SupplierListQuery, SupplierView } from '@chukua/common';
import { api } from '../../../../shared/shared.api';
import { toListParams } from '../../../../shared/policies/list-params';

export type { SupplierView };

export function listSuppliers(query: SupplierListQuery): Promise<Page<SupplierView>> {
  return api<Page<SupplierView>>(`/suppliers?${toListParams(query)}`);
}

export function createSupplier(input: SupplierInput): Promise<SupplierView> {
  return api<SupplierView>('/suppliers', { method: 'POST', body: JSON.stringify(input) });
}

export function updateSupplier(id: string, input: SupplierInput): Promise<SupplierView> {
  return api<SupplierView>(`/suppliers/${id}`, { method: 'PATCH', body: JSON.stringify(input) });
}

export async function deactivateSupplier(id: string): Promise<void> {
  await api<void>(`/suppliers/${id}/deactivate`, { method: 'POST' });
}

export async function reactivateSupplier(id: string): Promise<void> {
  await api<void>(`/suppliers/${id}/reactivate`, { method: 'POST' });
}
